export default {
  title: 'Changelogs',

  titles: {
    frontend: 'Application',
    backend: 'API'
  }
}
